<button
  type="button"
  class="wiki-help-btn"
  (click)="openHelp($event)"
  [attr.aria-label]="label"
  [title]="label">
  <span class="pi pi-question-circle"></span>
</button>
